const anySport = function(sportType) {
    return true;
};

export default anySport;